function copyURI(evt) {
  evt.preventDefault();

  const copyButton = evt.currentTarget;
  const tooltip = copyButton.querySelector(".copy-btn__tooltip");

  navigator.clipboard.writeText(window.location.href).then(() => {
    if (!tooltip) return;

    clearTimeout(copyButton.copyTooltipTimeout);
    tooltip.classList.add("is-visible");
    tooltip.setAttribute("aria-hidden", "false");

    copyButton.copyTooltipTimeout = setTimeout(() => {
      tooltip.classList.remove("is-visible");
      tooltip.setAttribute("aria-hidden", "true");
    }, 2000);
  });
}

const copyLinks = document.querySelectorAll(".copy-btn");

for (const copyLink of copyLinks) {
  copyLink.addEventListener("click", copyURI);
}
